var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 535,
    height: 668,
    viewBox: "0 0 535 668",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M461.613 161.614C480.883 180.883 490.517 190.517 495.593 202.769C500.667 215.02 500.667 228.645 500.667 255.895V500.667C500.667 563.52 500.667 594.947 481.14 614.473C461.613 634 430.187 634 367.333 634H167.333C104.479 634 73.0523 634 53.5263 614.473C34 594.947 34 563.52 34 500.667V167.333C34 104.479 34 73.0523 53.5263 53.5263C73.0523 34 104.479 34 167.333 34H278.77C306.02 34 319.647 34 331.897 39.0747C344.15 44.1493 353.783 53.7837 373.053 73.0523L461.613 161.614Z",
    stroke: "black",
    strokeWidth: 66.6667,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.d63cdd99b02275872ea7e35fbc25746b.svg";
export { ForwardRef as ReactComponent };